module.exports = __webpack_public_path__ + "img/500.5e6bf3ad.svg";